import api from "./api";

const professionalService = {
    list: async () => {
        const { data } = await api.get("/professionals");
        return data;
    },

    create: async (data) => {
        const { data: result } = await api.post("/professionals", data);
        return result;
    },

    update: async (id, data) => {
        const { data: result } = await api.put(`/professionals/${id}`, data);
        return result;
    },

    delete: async (id) => {
        const { data } = await api.delete(`/professionals/${id}`);
        return data;
    },
};

export default professionalService;
